import React, { useEffect, useState } from "react";
import { Renderer } from "./Renderer";
import { FormControl, MenuItem, Select } from '@mui/material';

import * as d3 from "d3";
import { useDashboard } from "../../model/DashboardContext";
import BarChart from "../barchart/barchart";
import {AllUSElectionData} from "../../model/data/StateElectionDataEntry"
import {USMapInteractionData, USMapTooltip} from "../geographic/USMapToolTip";

export type InteractionData = {
  xLabel: number;
  yLabel: string;
  xPos: number;
  yPos: number;
  value: number | null;
};

const COLOR_LEGEND_HEIGHT = 0;

//  total_votes: number;year:number , dem_electoral_votes : number, rep_electoral_votes : number
const Heatmap: React.FC = () => {
  const [hoveredCell, setHoveredCell] = useState<USMapInteractionData | null>(null);
  const [data, setData] = useState<AllUSElectionData[]>([]);//{ state: string, year: number, dem_percentage: number, num_voters_per_electoral_vote: number, total_votes:number, dem_electoral_votes : number, rep_electoral_votes : number,             winner: string,
    // point_lead: number }[]>([]);
  const [sortedData, setSortedData] = useState(data);
  const [sortBy, setSortBy] = useState("num_voters_per_electoral_vote"); // Default sort parameter
  // const [yScale, setyScale] = useState();
  const { dashboard, updateSelectedYear, updateSelectedStates } = useDashboard();
  const width = 275;
  const height = 720;
  const yearSelected = dashboard ? dashboard.year : undefined;



  useEffect(() => {
    const fetchDataForAllYears = async () => {
      if (dashboard) {
        const combinedData = dashboard.getAllElectionData
        // const allElectionData = dashboard.electionDataList;
        // if (allElectionData) {
        //   let combinedData: { 
        //     state: string, 
        //     year: number, 
        //     dem_percentage: number, 
        //     num_voters_per_electoral_vote: number, 
        //     total_votes: number,
        //     dem_electoral_votes : number,
        //     rep_electoral_votes : number,
        //     winner: string,
        //     point_lead: number
        //   }[] = [];
  
          // for (const electionDataForYear of allElectionData) {
          //   if (electionDataForYear) {
          //     const electionYear = electionDataForYear.year;
          //     const processedData = Object.values(electionDataForYear.data)
          //       .filter((entry: any) => entry.state_name !== "Totals")
          //       .map((entry: any) => ({
          //         state : entry.state_name,
          //         year : electionYear,
          //         dem_percentage : entry.dem_percentage,
          //         num_voters_per_electoral_vote : entry.num_voters_per_electoral_vote,
          //         total_votes : entry.total_votes, 
          //         dem_electoral_votes : entry.dem_electoral_votes,
          //         rep_electoral_votes : entry.rep_electoral_votes, 
          //         winner: entry.winner,
          //         point_lead: entry.point_lead

          //       }));
          //     combinedData = processedData.concat(combinedData);
          //   }
          // }
  
          // Sort combinedData by year in descending order
          const sorted = [...combinedData].sort((a, b) => {return a.year - b.year});
          // console.log(sorted.filter(d => d.state_name === undefined))
          setData(sorted.filter(d => d.state_name !== undefined));
        // }

      }
    };
  
    fetchDataForAllYears();
  }, [dashboard]);


  // Sorting function
  useEffect(() => {
    // const sortData = () => {
      const sorted = [...data.filter(d => d.year === yearSelected)].sort((a, b) => {
        switch (sortBy) {
          case "num_voters_per_electoral_vote":
            return 1/b.num_voters_per_electoral_vote - 1/a.num_voters_per_electoral_vote;
          case "total_votes":
            return b.total_votes - a.total_votes;
          // case "total_electoral_votes":
          //   return b.total_electoral_votes - a.total_electoral_votes;
          default:
            return 1/b.num_voters_per_electoral_vote - 1/a.num_voters_per_electoral_vote;
        }
      });
      const sortedStateOrder = sorted.map((d) => d.state_name);
      const reorderedData = [...data].sort((a, b) => {
        return sortedStateOrder.indexOf(a.state_name) - sortedStateOrder.indexOf(b.state_name);
      });
      setSortedData(reorderedData);
      // setData(sorted);
    // };
    // sortData();
  }, [data, sortBy, yearSelected]);


  // const values = sortedData.map((d) => d.point_lead * (d.winner === 'dem' ? -1 : 1)).filter((d): d is number => d !== null);
  // const max = d3.max(values) || 0;
  // const min = d3.min(values) || 0;

  // const colorScale = d3.scaleLinear<string>()
  //   .domain(THRESHOLDS.map((t) => t * (max-min)+min))
  //   .range(COLORS);

  // const colorScaleLegend = d3.scaleLinear<string>()
  //   .domain(THRESHOLDS.map((t) => t))
  //   .range(COLORS);

  const allYGroups = sortedData.map((d) => d.state_name);

  const yScale = d3.scaleBand<string>()
    .range([0, height - COLOR_LEGEND_HEIGHT])
    .domain(allYGroups)
    .padding(0.1);


  return (
    <div style={{ display: "flex", position: "relative", marginTop:'20px', marginLeft:'10px'}}>
      {/* Horizontal Bar Chart */}
      {/* <HorizontalBarChart */}
      <label htmlFor="sort" style={{ position: "absolute", marginTop: "-7px" , marginLeft:'15px',zIndex: 10, 'fontSize': 12}}>
        Sort by:
      </label>


      <FormControl 
        variant="outlined" 
        style={{ position: "absolute", zIndex: 10, marginLeft: "60px", marginTop: "-10px", width: 240, height: 30}}
      >
        <Select
          id="sort"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          displayEmpty
          variant="standard"
          sx={{ fontSize: '0.8rem' }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'top',   // Anchor to the top of the input
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'bottom', // Dropdown grows upwards
                        horizontal: 'left',
                    },
                }}
        >
          <MenuItem 
          value="num_voters_per_electoral_vote">Number of Voters per Electoral Vote</MenuItem>
          <MenuItem value="total_votes">Total Votes</MenuItem>
        </Select>
      </FormControl>

      
      <text style={{ position: "absolute", marginTop: "20px", width:"300px" , marginLeft:'100px', 'fontSize': 12, 'fontWeight':800}}>Voter Impact </text>{/* Number of Popular Votes per Electoral Vote */}

      <div style={{ display: "flex" }}>
        <div style={{ marginTop : "40px" }}>
          <BarChart
            data={sortedData} // Ensure sorted data is passed here
            width={width}
            height={height - COLOR_LEGEND_HEIGHT}
            yScale={yScale}
            dashboard = {dashboard}
            updateSelectedStates = {updateSelectedStates} // yScale based on sorted data
            // xScale={xBarScale} // xScale for the horizontal bar chart
          />
        </div>


        {/* Heatmap */}
          <div style={{marginTop: "40px", marginBottom: "0px"}}>
              <text style={{
                  position: "absolute",
                  marginTop: "-20px",
                  width: "300px",
                  marginLeft: '0px',
                  'fontSize': 12,
                  'fontWeight': 800
              }}>Dominance of votes in each state over the years
              </text>

              <Renderer
                  width={width}
                  height={height - COLOR_LEGEND_HEIGHT}
                  data={sortedData}
                  setHoveredCell={setHoveredCell}
                  // colorScale={dashboard?.colorScale}
                  yScale={yScale}
                  dashboard={dashboard}
                  updateSelectedStates = {updateSelectedStates}
                  updateSelectedYear = {updateSelectedYear}
              />
                <USMapTooltip
                    data={hoveredCell?.data || []}
                    position={hoveredCell?.position || { x: 0, y: 0 }}
                    width={800}
                    height={height - COLOR_LEGEND_HEIGHT}
              />
          </div>
      </div>
    </div>
  );
};


export default Heatmap;